import { useEffect } from "react";
import { useT } from "../i18n";
import { SHORTCUTS } from "./shortcuts";

// Keyboard-shortcuts reference (opened with ?). Matches the shell's modal pattern
// (fixed overlay + bordered panel); Esc / click-outside close it.
export function ShortcutsDialog({ onClose }: { onClose: () => void }) {
  const t = useT();
  useEffect(() => {
    const onKey = (e: KeyboardEvent) => e.key === "Escape" && onClose();
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [onClose]);

  return (
    <div className="fixed inset-0 z-50 grid place-items-center bg-black/60" onClick={onClose}>
      <div className="w-[420px] rounded-md border border-border bg-panel shadow-xl" onClick={(e) => e.stopPropagation()}>
        <div className="border-b border-border px-5 py-4 font-semibold">⌨ {t("Keyboard shortcuts")}</div>
        <div className="flex flex-col gap-2 px-5 py-5 text-sm">
          {SHORTCUTS.map((s) => (
            <div key={s.key} className="flex items-center justify-between">
              <span className="text-muted">{t(s.label)}</span>
              <kbd className="rounded border border-border bg-panel2 px-2 py-0.5 font-mono text-xs text-fg">{s.key}</kbd>
            </div>
          ))}
        </div>
        <div className="flex justify-end border-t border-border px-4 py-3">
          <button onClick={onClose} className="rounded border border-border px-3 py-1.5 text-xs hover:border-accent">
            {t("Close")}
          </button>
        </div>
      </div>
    </div>
  );
}
